export enum BroadcastType {
    OBJECT_IDS = 'object_ids',
    STRING = 'string',
    ACTION = 'action',
    QUERY_PARAMS = 'query-params',
    ANY = 'any',
}
